module.exports = __webpack_public_path__ + "static/media/jack_spade.f5e8e4ab.png";